<template>
    <ModelIndexLayout
        :createRoute="$route('admin::projects.create')"
        :modelNamePlural="__('admin::projects.projects')"
    >

        <Table
            :headings="[
                __('admin::labels.name'),
                __('admin::labels.department'),
                __('admin::labels.current_status'),
                __('admin::labels.created_at'),
                __('admin::labels.updated_at'),
            ]"
            :paginator="paginator"
            @filter="submit"
        >

            <template #filters>
                <Input :placeholder="__('admin::forms.search')" v-model="filter.search" variant="filter" />
            </template>

            <template #results>
                <tr v-for="project in paginator.data" :key="project.id">
                    <td>{{ project.name }}</td>
                    <td>{{ project.department?.name }}</td>
                    <td>{{ statusOptions[project.status] }}</td>
                    <td>{{ $datetime(project.created_at) }}</td>
                    <td>{{ $datetime(project.updated_at) }}</td>
                    <td>
                        <TableButton
                            variant="edit"
                            :href="$route('admin::projects.general.edit', { project: project.id })"
                        />
                        <TableButton
                            variant="destroy"
                            @delete="deleting = $route('admin::projects.destroy', { project: project.id })"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::projects.project') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </ModelIndexLayout>
</template>

<script>
    import DeleteDialog from '@/Components/DeleteDialog'
    import ModelIndexLayout from '@/Layouts/ModelIndexLayout'
    import Input from '@/Components/Input'
    import Table from '@/Components/Table'
    import TableButton from '@/Components/TableButton'

    export default {
        components: {
            DeleteDialog,
            Input,
            ModelIndexLayout,
            Table,
            TableButton,
        },
        props: {
            paginator: Object,
            request: Object,
            statusOptions: Object,
        },
        data() {
            return {
                filter: this.$inertia.form({
                    search: this.request.search,
                }),
                deleting: null,
            }
        },
        methods: {
            submit() {
                this.filter.get(this.$route('admin::projects.index'));
            },
        },
    }
</script>
